import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';
import {
  listVRFInZone,
  addVRFToZone,
  editVRFInZone,
  removeVRFFromZone,
} from '../../redux/zone/zone_vrf_actions';
import { searchVRFOutdoorByText } from '../../redux/vrf/vrf_outdoor_actions';

// FRS 4.2.1 - Zone VRF placement table.
// การวางต้องระบุ 2 FK (Outdoor + Indoor) จึง expand เป็นตัวเลือกคู่ (flat)
// value = "outdoorId:indoorId", label = "Outdoor / Indoor" (PaginateSelect รองรับเฉพาะ flat options)
const buildPairOptions = outdoors =>
  outdoors.reduce((acc, o) => {
    (o.indoor_types || []).forEach(i => {
      acc.push({ label: `${o.name} / ${i.name}`, value: `${o.id}:${i.id}` });
    });
    return acc;
  }, []);

export class VRFDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.search = { pageSize: Constants.DATA_TABLE_PAGE_SIZE, page: null, sorted: null, filtered: null };
    this.state = { categoryOption: 'all' };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.listVRF(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      { all: null, public: true, private: false }[category],
    );
    this.setState({ categoryOption: category });
  }

  render() {
    const {
      zoneId,
      vrfList,
      filteredCount,
      isLoading,
      addVRF,
      editVRF,
      removeVRF,
      isAdding,
      isEditing,
      isRemoving,
      errorMessage,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        Header: () => <b>{t('outdoor / indoor')}</b>,
        id: 'placement',
        accessor: row => `${row.outdoor.name} / ${row.indoor_type.name}`,
        ...textColumn,
        entity: {
          list: (text, page) => searchVRFOutdoorByText(text, page, zoneId)
            .then(response => buildPairOptions(response.data)),
        },
      },
      {
        Header: () => <b>{t('indoor form')}</b>,
        accessor: 'indoor_type.indoor_form',
        ...textColumn,
        width: 110,
      },
      {
        id: 'indoorCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: row => `${row.indoor_type.cooling_capacity} ${row.indoor_type.unit}`,
        ...textColumn,
        width: 130,
      },
      {
        Header: () => <b>Q_outdoor (W)</b>,
        accessor: 'outdoor.q_outdoor',
        ...coeColumn,
        width: 120,
      },
      {
        Header: () => <b>COP</b>,
        accessor: 'outdoor.cop',
        Cell: row => (row.value == null ? t('pending') : row.value),
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...textColumn,
        width: 80,
        attr: { type: 'number', isRequired: true, props: { min: 1 } },
      },
    ];

    const relationship = {
      create: ({ entityId, quantity }) => {
        const [outdoorId, indoorTypeId] = String(entityId).split(':');
        return addVRF(outdoorId, indoorTypeId, quantity);
      },
      edit: ({ id, quantity }) => editVRF(id, quantity),
      delete: id => removeVRF(id),
      isCreating: isAdding,
      isEditing,
      isDeleting: isRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={columns}
          data={vrfList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => `${item.outdoor.name} / ${item.indoor_type.name}`}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  vrfList: state.zoneVRF.orderedIds.map(id => state.zoneVRF.objects[id]),
  isLoading: state.zoneVRF.isLoading,
  isAdding: state.zoneVRF.isCreating,
  isEditing: state.zoneVRF.isEditing,
  isRemoving: state.zoneVRF.isDeleting,
  errorMessage: state.zoneVRF.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listVRF: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listVRFInZone(pageSize, page, sorted, filtered, isPublic, ownedProps.zoneId))),
  addVRF: (outdoorId, indoorTypeId, quantity) =>
    defaultRejectHandler(dispatch(addVRFToZone(outdoorId, indoorTypeId, ownedProps.zoneId, quantity))),
  editVRF: (id, quantity) => defaultRejectHandler(dispatch(editVRFInZone(id, quantity))),
  removeVRF: id => defaultRejectHandler(dispatch(removeVRFFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(VRFDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/VRFDataTable.js